<div *ngIf="show" class="w-100 loader-demo d-flex align-items-center justify-content-center">
  <div class="square-spin">
      <div></div>
  </div>
</div>